<script>
import { Btn } from "uiv";
import { mapGetters } from "vuex";

import Placeholder from "../Placeholder/Filtros/Clear.vue";

export default {
  components: { Btn, Placeholder },
  computed: {
    ...mapGetters(["isPreloader", "isMaster"])
  },
  methods: {
    clear() {
      this.$emit("clear");
      //this.$store.commit("clearFiltros");
    }
  }
};
</script>

<template>
  <div>
    <btn type="warning" block @click="clear" v-if="isMaster">
      <i class="mdi mdi-filter-remove"></i>
      ELIMINAR FILTROS
    </btn>
    <placeholder v-else></placeholder>
  </div>
</template>

<style lang="scss" scoped>
.btn {
  padding: 9px 15px;
  font-size: 14px;
  font-style: normal;
  border-radius: 4px;
  border-color: #ffc107;
  background-color: #ffc107;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  > .mdi {
    font-size: 15px;
    margin-right: 5px;
  }
}
</style>